import TabPage from "../../factories/tab-page";
import Bao from "../../services/bao-service";
import * as $ from "jquery";
import * as ko from "knockout";
import baoRouter from "../../services/bao-router";
import GenericListSearchTab from "../../factories/generic-list-search-tab";
import WorkItemTab from "../work-item-tab";
import UniversalField from "../universalfield";
import { WorkItemRelationTabNames } from "../../constants/work-item-relation-tab-names";
import { WorkItemTabTypes } from "../../constants/work-item-tab-types";

/**
 * Class representing a universal field tab for work items.
 */
class WorkItemTabUniversalField extends GenericListSearchTab {

    //#region Fields

    /** Page size for the universal field list. */
    PageSize = ko.observable<number>(20);

    /** Whether saving is allowed. */
    SaveAllowed: KnockoutObservable<boolean>;

    // ID of the currently selected UniversalField
    SelectedUniversalFieldId = ko.observable<string>();

    /** URL of the controller for this tab */
    ControllerUrl = "WorkItemTabUniversalField";

    //#endregion

    //#region Constructors

    /**
     * Creates an instance of WorkItemTabUniversalField.
     * @param {TabPage} tabPage - The parent tab page.
     * @param {any} parent - The parent context.
     */
    constructor(tabPage: TabPage, parent: any) {
        super(tabPage, parent);
        this.SaveAllowed = parent.SaveAllowed;
        this.Models.subscribe(() => {
            this.Selection([]);
        });
    }

    //#endregion

    //#region Properties

    public static readonly MOVE_UP_KEY: string = "WorkItemTabUniversalFieldMoveUp";
    public static readonly MOVE_DOWN_KEY: string = "WorkItemTabUniversalFieldMoveDown";


    /**
    * Parent of Tab
    */
    Parent: WorkItemTab | UniversalField;

    //#endregion

    //#region Public Methods

    /**
     * Returns a custom filter.
     * @returns {null}
     */
    CustomFilter() {
        return null;
    }

    /**
     * Toggles the state of toolbar buttons.
     */
    ToggleToolbarButtons() {
        super.ToggleToolbarButtons();
        ko.utils.arrayForEach(this.ToolbarButtons(), (button: any) => {
            const key = ko.unwrap(button.ActionKey);
            if (key === WorkItemTabUniversalField.MOVE_UP_KEY || key === WorkItemTabUniversalField.MOVE_DOWN_KEY) {
                button.Enabled(this.Selection() != null && this.Selection().length > 0);
                button.Visible(this.IsParentWorkItemTab());
            }
        });
    }

    /**
     * Handles custom toolbar button click events.
     * @param {any} action - The action to perform.
     */
    CustomToolbarClick = (action) => {
        const key = ko.unwrap(action.ActionKey);
        if (key === WorkItemTabUniversalField.MOVE_UP_KEY || key === WorkItemTabUniversalField.MOVE_DOWN_KEY) {
            this.moveWorkItemTabUniversalField(key.replace("WorkItemTabUniversalField", ""));
        }
    };

    /**
    * Checks if the item is complete.
    * @returns {JQueryPromise<boolean>} - Promise resolving to true.
    */
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        return $.Deferred<boolean>().resolve(true).promise();
    }

    /**
     * Opens the edit dialog for an item.
     * @param {any} item - The item to edit.
     */
    Edit(item: any): void {
        if (item) {
            this.Dialog(ko.unwrap(item.PrimaryKeyValue));
        }
    }

    /** 
     * SearchType of this GenericListSearchTab 
     */
    SearchType(): string {
        if (this.Parent.ClientRoute() == WorkItemRelationTabNames.WORK_ITEM_TAB) {
            return WorkItemRelationTabNames.UNIVERSAL_FIELD;
        }
        else {
            return WorkItemRelationTabNames.WORK_ITEM_TAB;
        }
    }

    /**
    * Check if Parent is WorkItemTab
    * @returns true or false
    */
    IsParentWorkItemTab = (): boolean => {
        return this.Parent.ClientRoute() == WorkItemRelationTabNames.WORK_ITEM_TAB;
    }

    /**
     * Check if Parent is UniversalField
     * @returns true or false
     */
    IsParentUniversalField = (): boolean => {
        return this.Parent.ClientRoute() == WorkItemRelationTabNames.UNIVERSAL_FIELD;
    }

    /**
     * Override init method to not override title set by parent Module
     * @returns JQuery Promise
     */
    init(): JQueryPromise<void> {
        this.TabPage.IsLoading(true);

        if (this.IsParentUniversalField()) {
            this.SearchConfig.CustomFilter = {
                SessionTabId: this.SessionTabId,
                WorkItemTabTypeId: WorkItemTabTypes.UniversalField
            };
        }

        return Bao.post(this.UrlInit(), JSON.stringify({
            sessionTabId: this.SessionTabId,
            parentId: this.GetParentId(),
            customFilter: this.CustomFilter(),
            sorting: this.Sorting(),
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize()
        }), (result: Factories.GenericListResponse.InitResponse) => {
            this.Models(result.Models);
            this.TotalRows(result.TotalRows);
            this.PermissionAdd = result.Definition.PermissionAdd;
            this.PermissionEdit = result.Definition.PermissionEdit;
            this.PermissionRemove = result.Definition.PermissionRemove;
            this.BindingToolbar.formName = result.Definition.FormName;
            this.BindingToolbar.applicationId = result.Definition.ApplicationId;
            this.TabPage.DirtyFlag.reset();
        }).always(() => {
            this.TabPage.IsLoading(false);
        });
    }

    //#endregion

    //#region Protected Methods

    /**
     * Moves the WorkItemTabUniversalField up or down.
     * @protected
     * @param {string} action - The action to perform (MoveUp/MoveDown).
     */
    protected moveWorkItemTabUniversalField = (action: string) => {
        this.TabPage.IsLoading(true);
        const guidList = this.Selection().map(item => ko.unwrap(item.UniversalFieldId));

        Bao.post(`${this.ControllerUrl}/WorkItemTabUniversalField${action}`, JSON.stringify({
            sessionTabId: this.SessionTabId,
            id: guidList
        }))
            .then(() => this.Get())
            .then(() => this.TabPage.DirtyFlag(true));
    }

    //#endregion

    /**
     * Navigates to a specific universal field.
     * @param {number} index - The index of the universal field.
     * @param {any} model - The model of the universal field.
     */
    link(index: number, model: any): void {
        const linkHash = `universalField/${model.UniversalFieldId}`;
        baoRouter.setHash(linkHash);
    }
}
export default WorkItemTabUniversalField;